import { Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, styled } from "@mui/material";
import { useRef, useState } from "react";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function DocumentosAdjuntosSolicitud(props) {
    const [documentoAdjunto, setDocumentoAdjunto] = useState({ ruta: '', descripcion: '', documentos: new FormData(), indice: 0 })

    const [loading, setLoading] = useState(false)

    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const { documentos, setDocumentos, ventana, idAutor } = props
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [indice, setIndice] = useState(1)
    const limpiar = useRef(null)
    const documentoF = useRef(null)

    const columns = [
        { id: 'documentos', label: 'Documentos', width: 150, align: 'justify' },
        { id: 'descripcion', label: 'Descripción', width: 150, align: 'justify' },
        { id: 'borrar', label: '', width: 50, align: 'center' }
    ];

    const handleDelete = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        setDocumentos(documentos.filter(documentos => documentos.indice !== registro.indice))
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/borrarDocumento`, {
            method: "DELETE",
            headers: {
                "ruta": registro.ruta,
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        //console.log(`${resDelete.status}`)

    }

    const handleDocumentos = async (event) => {
        const files = event.target.files
        if (!files) {
            return
        }

        documentoAdjunto.documentos.delete('PDF')
        //console.log(`event.target.files ${files.length}`)

        const file = files[0]
        //console.log(`Documento ${file.name}`)
        let error = false
        documentos.map((documentoGuardado) => {
            if (file.name === documentoGuardado.documentos.get('PDF').name) {
                setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de arriba, si deseas cambiar la descripción bórralo (icono de bote de basura) y vuelve a registrarlo')
                setErrorDocumentoPDF(true)
                error = true
            }
        })
        if (Boolean(error))
            return

        /*let regex = /([^-\w.]*)/gm;
        const nombreArchivo = file.name.replace(regex, '');
        console.log(`nombreArchivo ${nombreArchivo}`)
        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarDocumento`, {
            method: "GET",
            headers: {
                "nombre": nombreArchivo
            }
        })
        if (resVerificar.status === 200) {
            setErrorDocumentoPDF(true)
            setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre, por favor renómbralo')
            return
        }
        else {
            setErrorDocumentoPDF(false)
            setHelperTextDocumentoPDF('')
        }*/
        if (event.target.value) {
            //console.log(`event.target.value ${event.target.value} ${event.target.value.endsWith(".jpg")}`)
            if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf") || event.target.value.endsWith(".PNG") || event.target.value.endsWith(".png") || event.target.value.endsWith(".JPG") || event.target.value.endsWith(".jpg") || event.target.value.endsWith(".JPEG") || event.target.value.endsWith(".jpeg")) {

                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            else {
                setHelperTextDocumentoPDF(`Formato de archivo no válido, se requiere PDF PNG, JPG o JPEG`)
                setErrorDocumentoPDF(true)
                return
            }
            if (file.size > 5242880) {
                setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                setErrorDocumentoPDF(true)
                return
            }
            else {
                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
            // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
            /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
            {
                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            
            else {
                setHelperTextDocumentoPDF('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                setErrorDocumentoPDF(true)
                return
            }*/
            setHelperTextDocumentoPDF('')
            setErrorDocumentoPDF(false)
        }

        documentoAdjunto.documentos.append('PDF', file)

    }

    const almacenarTemporalmente = async (e) => {
        setLoading(true)
        e.preventDefault()
        e.stopPropagation()
        const archivoPDF = new FormData();
        const file = documentoAdjunto.documentos.get('PDF')
        if (!file) {
            setErrorDocumentoPDF(true)
            setHelperTextDocumentoPDF('Debe seleccionar un archivo')
            setLoading(false)
            return
        }
        setErrorDocumentoPDF(false)
        setHelperTextDocumentoPDF('')
        archivoPDF.append('documento', documentoAdjunto.documentos.get('PDF'));
        const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
            method: "POST",
            body: archivoPDF
        })
        const ruta = (await resUploadPDF.json()).ruta

        documentoAdjunto.ruta = ruta
        documentoAdjunto.idAutor = idAutor
        setIndice(indice + 1)
        documentoAdjunto.indice = indice
        documentos.push({ ...documentoAdjunto })
        if (documentoF.current)           
            documentoF.current.value = null
        //document.getElementById('documento').value = null
        setDocumentoAdjunto({ ruta: '', descripcion: '', documentos: new FormData(), indice })
        if (limpiar.current)           
            limpiar.current.click()
        setLoading(false)
    }

    return (
        <Grid item xs={12} sm={12}>
            <Box sx={{ flexGrow: 1, marginLeft: '20px', marginTop: '50px' }}>
                <Grid container spacing={2}>
                    <Grid container xs={12} md={12} lg={12}>
                        <Grid xs={12} md={12} spacing={2}>
                            <Item>
                                <Box
                                    id="category-c"
                                    sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                                >
                                    Documentos Adjuntos<Box component="div" sx={{ textTransform: 'none', fontWeight: 500, fontStyle: 'italic' }}>(Adjuntar sólo si no es obligatorio el documento que desea añadir. En caso que sean muchos documentos se recomienda subirlos a drive y colocar el enlace en el campo <span style={{ color: 'rgb(25, 118, 210)' }}>Documentos anexos (enlace de Drive)</span>)</Box>
                                    <Box component="div" sx={{ textTransform: 'none', fontWeight: 500, fontStyle: 'italic' }}>{ventana ? <>En esta ventana puede añadir todos los documentos que requiera, una vez que termine ciérrela 'CERRAR VENTANA' y presione 'ACTUALIZAR'. Los documentos aparecerán en el listado de las solicitudes</> : <>En esta sección puede añadir los documentos que requiera, una vez que termine de añadir presione <span style={{ color: 'rgb(25, 118, 210)' }}>SOLICITAR</span>. Los enlaces a los documentos aparecerán en el listado de las solicitudes</>}</Box>

                                    <TableContainer sx={{ mb: 5, display: !documentos || documentos.length === 0 ? 'none' : 'block', width: '100%' }}>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow key='encabezado'>
                                                    <TableCell key='ninguna' align="center" colSpan={4}>
                                                        Documentos para registrar
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='encabezado2'>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{ top: 57, minWidth: column.minWidth }}
                                                        >
                                                            {column.label}
                                                        </TableCell>

                                                    ))}
                                                    <TableCell style={{ top: 57 }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    documentos && documentos.length > 0 ? documentos
                                                        .map((row, index) => {
                                                            return (
                                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                                                                    {
                                                                        columns.map((column) => {
                                                                            const value = row[column.id];

                                                                            // total=Number(total)+Number(value)
                                                                            // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                                                                            return (
                                                                                <TableCell key={column.id} align={column.align} style={{ wordBreak: 'break-word' }}>
                                                                                    {column.id === 'documentos' ? `${value.get('PDF').name}` : value}
                                                                                </TableCell>
                                                                            );
                                                                        })}
                                                                    <TableCell><Tooltip title="Eliminar"><IconButton variant='text' style={{ color: 'darkred' }} onClick={() => handleDelete(row)}><i className="bi bi-trash3"></i></IconButton></Tooltip></TableCell>
                                                                </TableRow>
                                                            );
                                                        }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                                        <TableCell align='center' colSpan={4}>
                                                            No hay comprobantes registrados
                                                        </TableCell>

                                                    </TableRow>}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Box component="div" aria-labelledby="category-c" sx={{ p: 2, textAlign: "left" }}>
                                        <form onSubmit={almacenarTemporalmente}>
                                            <Grid container direction='row' justifyContent='center' spacing={2}>
                                                <Grid item sm={12} xs={12}>
                                                    <TextField label='Documento (PDF PNG, JPG o JPEG)' focused name='documento' ref={documentoF} accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} sx={{ width: '100%' }} type="file" onChange={handleDocumentos} />
                                                </Grid>
                                                <Grid item sm={12} xs={12}>
                                                    <TextField label='Descripción' focused name='descripcion' multiline fullWidth
                                                        onChange={(event) => {
                                                            documentoAdjunto.descripcion = event.target.value;
                                                            //console.log(documentoAdjunto)
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={loading}>
                                                        Subir documento
                                                    </Button>
                                                    <Button variant='contained' color='primary' type='reset' style={{ marginTop: 20, marginLeft: 20 }} ref={limpiar} onClick={() => { setErrorDocumentoPDF(false); setHelperTextDocumentoPDF(''); setDocumentoAdjunto({ ruta: '', descripcion: '', documentos: new FormData(), indice }) }}>Limpiar</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </Box>
                                </Box>
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

